import React from 'react'
import {Box,TextInput, Form, FormField,DataTable,Text} from 'grommet'
import {Notes, DocumentCloud} from 'grommet-icons';
import {RequestButton} from './utils/shared/shipmentViewFunctions'
import CreateDepartmentLayer from './createDepartmentLayer'

function EditOrgForm (props) {
    let imagePrev;
    if (props.org.logo_key === ""){
        imagePrev = ( <FormField margin='small' label='Logo'  > <TextInput icon={<DocumentCloud/>}type="file" onChange={props.handleDocsChange} /> </FormField>)
    } else {
        imagePrev = ( <FormField margin='small' label='Logo'  > <TextInput icon={<DocumentCloud/>}type="file" onChange={props.handleDocsChange} /> </FormField>)
    }
  return ( 
    <Form value={props.org} onSubmit={props.handleSubmit} onChange={nextValue => props.setOrg(nextValue)}>
    <Box direction='row' flex="grow" margin={{top: 'large'}}>
        <FormField required label='Orginisation Name' name='name' margin='small' > <TextInput icon={<Notes />} name='name' placeholder="Enter Orginisation Company Name" /> </FormField>
        <FormField required label='Organisation Markup' name='markup' margin='small' >
            <TextInput icon={<Notes />} name='markup' type='number' placeholder="Enter Organisation Markup" />
        </FormField>    
        <FormField label='Departments' width='small' margin='small'>
        <DataTable onClickRow={() => {}} width='small' margin='small' columns={[{ header: <Text size='xsmall' weight='bold'>Name</Text>, property: "name", pad: 'xsmall', sortable: true, search: false, render: (datum) => <Text size='xsmall'>{datum.name}</Text>}]} data={props.org.departments} step={10} />
    </FormField>
    <CreateDepartmentLayer org={props.org}/>
    </Box>
    <Box direction='row' justify='center'>
    {imagePrev}
    </Box>
    <Box direction='row' justify="center" margin={{top: 'medium',bottom:'medium'}}> <RequestButton load={props.load} label={"Update Organisation"} /> </Box>
   </Form>
  )
}

export default EditOrgForm
